import classnames from 'classnames';
import React, { FC, useMemo } from 'react';

import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';

import { FavoriteAccount } from '../../components/FavoriteAccount';
import { accountListSelector, useSuspendedAccounts } from '../../fetchHooks/useAccount';
import { useSuspendedFavoriteAccount } from '../../fetchHooks/useFavoriteAccount';

const MobileAccountContent: FC = () => {
    const { data: accounts } = useSuspendedAccounts({ select: accountListSelector });

    const { data: favoriteAccountNumber } = useSuspendedFavoriteAccount();

    const favoriteAccount = useMemo(
        () => accounts.find((account) => account.accountNumber.value === favoriteAccountNumber?.value),
        [favoriteAccountNumber, accounts],
    );

    return <FavoriteAccount className={classnames({ native: runningInRNWebView })} account={favoriteAccount} />;
};

export default MobileAccountContent;
